<template>
    <router-view></router-view>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        async mounted() {
            await this.initLayout();
        },
        components: {},
        computed: mapState([
            'loginUser'
        ]),
        methods: {
            ...mapActions([
                'initLayout'
            ])
            /*onPageResize() {
                this.refreshResizeTag();
            }*/
        }
    }
</script>
